




















































































































































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import SecondaryWalletInterestSettingsEditDialog from '@/components/Accounts/DepositAccounts/Wallets/SecondaryWallets/WalletInterest/SecondaryWalletInterestSettingsEditDialog.vue';
import InterestRateType from '@/models/Products/InterestRateType';
import PostingScheduleType from "@/models/Shared/PostingScheduleType";
import PeriodType from '@/models/Shared/PeriodType';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import Currency from '@/filters/Currency';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'SecondaryWalletInterestSettingsRead', components: { SecondaryWalletInterestSettingsEditDialog } })
export default class extends SaascadaVue {

    PermissionUtils = PermissionUtils;
    InterestRateType = InterestRateType;
    PeriodType = PeriodType;

    get currentWallet() {
        return DepositAccountModule.currentDepositAccountWallet;
    }

    get isInterestSettingsOverridable() {
        return this.currentWallet.walletSettings.depositInterestSettings.overridable;
    }

    get isInterestSettingsOverridden() {
        return this.currentWallet.walletSettings.depositInterestSettings.overridden;
    }

    get isFixedSchedule() {
        return this.currentWallet.walletSettings.depositInterestSettings.postingScheduleType === PostingScheduleType.FixedSchedule;
    }

    get rateSourceRate() {
        // This is not currently provided in the API so calculate it manually
        return this.currentWallet.walletSettings.depositInterestSettings.cumulativeRateValue - this.currentWallet.walletSettings.depositInterestSettings.rateValue;
    }

    get cumulativeRateCalculationText() {
        // A text representation of the cumulative rate calculation
        return `${this.currentWallet.walletSettings.depositInterestSettings.rateSourceIdentifier.entityName} ${this.rateSourceRate}% + ${this.$t('pageText.products.fields.rateValue')} ${this.currentWallet.walletSettings.depositInterestSettings.rateValue}%`;
    }

    async deleteWalletInterestAccountSettings() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete the overridden account settings?', options);
        if (result) {
            await DepositAccountModule.deleteAccountSecondaryWalletInterestSettings();
        }
    }

}
